export default "__VITE_ASSET__Dy2VH3xF__"